import * as types from '../constants/ActionTypes';
import update from 'immutability-helper';

const initialState = {  
    AgenciesList: [],
    countryId: 88,
    perfectureId: "",
    municipalityId: "",
};

export default function searchAgencies (state = initialState, action) {
    switch (action.type) {
        case types.SET_AGENCIES_COUNTRY_ID:
            return update(state, {countryId: {$set: action.countryId}, perfectureId: {$set: null}, municipalityId: {$set: null} })
        case types.SET_AGENCIES_PERFECTURE_ID:
            return update(state, {perfectureId: {$set: action.perfectureId}, municipalityId: {$set: null} })
        case types.SET_AGENCIES_MUNICIPALITY_ID:
            return update(state, {municipalityId: {$set: action.municipalityId} })
        case types.SET_AGENCIES_LIST:
            return update(state, {AgenciesList: {$set: action.agenciesList} })
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_allagencies.js